<template>
  <div>
    <form-wizard
      ref="wizard"
      color="#B9524F"
      :title="null"
      :subtitle="null"
      shape="square"
      :next-button-text="$t('next')"
      :finish-button-text="$t('submit')"
      :back-button-text="$t('previous')"
      class="mb-3"
      @on-complete="formSubmitted"
    >

      <!-- accoint details tab -->
      <tab-content
        :before-change="validationFormType"
        title="活動類型"
      >
        <validation-observer
          ref="accountCampaign"
          tag="form"
        >
          <div
            v-show="!secondary"
            class="parent-type"
          >
            <b-row>
              <b-col
                cols="12"
                class="mb-2"
              >
                <h5 class="mb-0">
                  <b>請選擇活動類型</b>
                </h5>
              </b-col>
            </b-row>
            <b-row
              v-for="i in Math.ceil(campaignTypes.length / 4)"
              :key="i.name"
            >
              <b-col
                v-for="type in campaignTypes.slice((i - 1) * 4, i * 4)"
                :key="type.name"
                class="col-md-3 col-sm-6"
                cols="12"
              >
                <b-card
                  v-b-tooltip.hover.top="type.desc"
                  v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                  class="cursor-pointer text-center mb-2 mx-50 ecommerce-card"
                  :class="{'border-secondary': isActive[type.name]}"
                  @click="goNext(type)"
                >
                  <b-img
                    :src="require(`@/assets/images/icons/campaign-icons/${type.name}.svg`)"
                    alt="type img"
                    width="55%"
                  />
                  <b-card-text class="text-truncate mb-0 mt-1">
                    {{ type.labor }}
                  </b-card-text>
                </b-card>
              </b-col>
            </b-row>
          </div>
          <div
            v-show="secondary"
            class="child-type"
          >
            <b-row>
              <b-col
                cols="12"
                class="mb-2"
              >
                <b-button
                  v-ripple.400="'rgba(40, 199, 111, 0.15)'"
                  variant="gradient-primary"
                  class="btn-icon"
                  @click="goBack"
                >
                  <feather-icon
                    size="20"
                    icon="CornerUpLeftIcon"
                  />
                </b-button>
              </b-col>
            </b-row>
            <b-row
              v-for="i in Math.ceil(secondaryList.length / 4)"
              :key="i.name"
            >
              <b-col
                v-for="icon in secondaryList.slice((i - 1) * 4, i * 4)"
                :key="icon.name"
                class="col-md-3 col-sm-6"
                cols="12"
              >
                <b-card
                  v-b-tooltip.hover.top="icon.desc"
                  v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                  class="cursor-pointer text-center mb-2 mx-50 ecommerce-card"
                  :class="{'border-secondary': isActive.secondary[icon.name]}"
                  @click="goNext(icon)"
                >
                  <b-img
                    :src="require(`@/assets/images/icons/campaign-icons/${icon.name}.svg`)"
                    alt="type img"
                    width="55%"
                  />
                  <b-card-text class="text-truncate mb-0 mt-1">
                    {{ icon.labor }}
                  </b-card-text>
                </b-card>
              </b-col>
            </b-row>
          </div>
        </validation-observer>
      </tab-content>

      <!-- Logo tab -->
      <tab-content
        title="活動LOGO"
      >
        <validation-observer
          ref="logoCampaign"
          tag="form"
        >
          <b-row>
            <b-col
              cols="12"
              class="mb-2"
            >
              <h5 class="mb-0">
                <b>上傳LOGO（非必要）</b>
              </h5>
            </b-col>
            <b-col cols="12">
              <my-upload
                v-model="imageUpload"
                lang-type="zh-tw"
                field="img"
                img-format="png"
                @crop-success="cropSuccess"
              />
              <img :src="campaignForm.imgDataUrl">
            </b-col>
            <b-col
              cols="12"
              class="mb-2"
            >
              <b-button
                v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                variant="outline-primary"
                @click="imageUpload = !imageUpload"
              >
                上傳
              </b-button>
              <span
                v-if="campaignForm.imgDataUrl !== ''"
                class="ml-2"
                @click="removeImg('imgDataUrl')"
              >移除</span>
            </b-col>
          </b-row>
        </validation-observer>
      </tab-content>

      <!-- Logo tab -->
      <tab-content
        title="疾病管制屬"
      >
        <validation-observer
          ref="govQrcode"
          tag="form"
        >
          <b-row>
            <b-col
              cols="12"
              class="mb-2"
            >
              <h5 class="mb-0">
                <b>上傳 Qrcode（非必要）</b>
              </h5>
            </b-col>
            <b-col cols="12">
              <my-upload
                v-model="QrcodeUpload"
                lang-type="zh-tw"
                field="img"
                img-format="png"
                @crop-success="cropQrcode"
              />
              <img :src="campaignForm.govQrcode">
            </b-col>
            <b-col
              cols="12"
              class="mb-2"
            >
              <b-button
                v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                variant="outline-primary"
                @click="QrcodeUpload = !QrcodeUpload"
              >
                上傳
              </b-button>
              <span
                v-if="campaignForm.govQrcode !== ''"
                class="ml-2"
                @click="removeImg('govQrcode')"
              >移除</span>
            </b-col>
            <b-col cols="12">
              <div
                class="pt-1"
              >
                <span>申請政府簡訊實聯制 Qrcode <b-link
                  href="https://emask.taiwan.gov.tw/real"
                  target="_blank"
                >這邊申請</b-link></span>
              </div>
              <div>
                <span>如何從 PDF 中下載 Qrcode？<b-link
                  href="https://pdfcandy.com/extract-images.html"
                  target="_blank"
                >使用此網站</b-link></span>
              </div>
            </b-col>
          </b-row>
        </validation-observer>
      </tab-content>

      <!-- campaign info tab -->
      <tab-content
        title="活動資訊"
        :before-change="validationFormInfo"
      >
        <validation-observer
          ref="infoRules"
          tag="form"
        >
          <b-row>
            <b-col
              cols="12"
              class="mb-2"
            >
              <h5 class="mb-0">
                請輸入活動資訊
              </h5>
            </b-col>
            <b-col md="6">
              <b-form-group
                label="名稱（活動或是商店）"
                label-for="campaign-name"
              >
                <validation-provider
                  #default="{ errors }"
                  name="Campaign Name"
                  rules="required"
                >
                  <b-form-input
                    id="campaign-name"
                    v-model="campaignForm.campaignName"
                    placeholder="這是一個活動"
                    :state="errors.length > 0 ? false:null"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <validation-provider
                #default="{ errors }"
                ref="contactNumber"
                name="Contact number"
                rules="required"
              >
                <b-form-group
                  label="聯絡電話"
                  label-for="contact-number"
                >
                  <VuePhoneNumberInput
                    id="phoneNumber"
                    v-model="phoneNumber"
                    :size="phoneInput.size"
                    :error-color="phoneInput.errorColor"
                    :color="phoneInput.color"
                    :no-flags="phoneInput.noFlags"
                    :default-country-code="phoneInput.default"
                    :show-code-on-list="phoneInput.showCode"
                    :preferred-countries="phoneInput.top"
                    :no-validator-state="phoneInput.noState"
                    :error="phoneInput.error"
                    :required="phoneInput.required"
                    :img-format="phoneInput.imgFormat"
                    @update="updateForm"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>

            <b-col md="6">
              <b-form-group
                label="店家代號 (英文、數字、底線、破折号)"
                label-for="slug"
              >
                <validation-provider
                  #default="{ errors }"
                  ref="slug"
                  name="slug"
                  rules="required|alpha-dash|min:3|max:30"
                >
                  <b-form-input
                    id="slug"
                    v-model="campaignForm.slug"
                    placeholder="掃描不到 Qrcode 時使用"
                    :state="errors.length > 0 ? false:null"
                    :formatter="formatter"
                  />
                  <div v-if="errors[0]">
                    <small class="text-danger">{{ errors[0] }}</small>
                  </div>
                  <div v-else>
                    <small class="text-muted">liff.trackhelps.com/{{ campaignForm.slug }}</small>
                  </div>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="6" />

            <b-col md="12">
              <validation-provider
                #default="{ errors }"
                name="address"
                rules="required"
              >
                <b-form-group
                  label="地址"
                  label-for="address"
                >
                  <b-form-input
                    id="address"
                    v-model="campaignForm.address"
                    placeholder="地址"
                    :state="errors.length > 0 ? false:null"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col md="6">
              <validation-provider
                #default="{ errors }"
                name="Country"
                rules="required"
              >
                <b-form-group
                  label="國家"
                  label-for="country"
                >
                  <b-form-input
                    id="country"
                    v-model="campaignForm.country"
                    placeholder="國家"
                    :state="errors.length > 0 ? false:null"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col md="6">
              <validation-provider
                #default="{ errors }"
                name="Zip Code"
                rules="required"
              >
                <b-form-group
                  label="郵遞區號"
                  label-for="zip"
                >
                  <b-form-input
                    id="zip_code"
                    v-model="campaignForm.zip"
                    placeholder="郵遞區號"
                    :state="errors.length > 0 ? false:null"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>
          </b-row>
        </validation-observer>
      </tab-content>

      <!-- Review  -->
      <tab-content
        title="確認資料"
      >
        <validation-observer>
          <b-row>
            <b-col
              cols="12"
              class="mb-2"
            >
              <h5 class="mb-0 text-primary">
                請確定活動資訊是否正確（地圖上是否正確）
              </h5>
            </b-col>
            <b-col
              cols="12"
              class="col-md-6"
            >
              <dl class="row match-height">
                <dt
                  class="col-sm-3"
                >
                  活動名稱
                </dt>
                <dd
                  class="col-sm-7 text-dark font-weight-bolder"
                >
                  {{ campaignForm.campaignName }}
                </dd>
              </dl>
              <dl class="row">
                <dt class="col-sm-3">
                  店家代號
                </dt>
                <dd class="col-sm-7 text-dark font-weight-bolder">
                  liff.trackerhelps.com/{{ campaignForm.slug }}
                </dd>
              </dl>
              <dl class="row">
                <dt class="col-sm-3">
                  聯絡電話
                </dt>
                <dd class="col-sm-7 text-dark font-weight-bolder">
                  {{ campaignForm.contactNumber }}
                </dd>
              </dl>
              <dl class="row">
                <dt class="col-sm-3">
                  地址
                </dt>
                <dd class="col-sm-7 text-dark font-weight-bolder">
                  {{ campaignForm.address }}
                </dd>
              </dl>
              <dl class="row">
                <dt class="col-sm-3">
                  類型
                </dt>
                <dd class="col-sm-7 text-dark font-weight-bolder">
                  <b-badge
                    v-for="(type, idx) in campaignForm.types"
                    :key="idx"
                    class="profile-badge mr-1"
                    variant="light-primary"
                  >
                    {{ type }}
                  </b-badge>
                </dd>
              </dl>
            </b-col>
            <b-col
              cols="12"
              class="col-md-6 mb-2"
            >
              <img :src="campaignForm.imgDataUrl">
            </b-col>
            <b-col
              cols="12"
              class="col-md-6 mb-2"
            >
              <img :src="googleMapURL">
            </b-col>
            <b-col
              cols="12"
              class="col-md-6 mb-2"
            >
              <img :src="campaignForm.govQrcode">
            </b-col>
          </b-row>
        </validation-observer>
      </tab-content>
    </form-wizard>
  </div>
</template>

<script>
import { FormWizard, TabContent } from 'vue-form-wizard'
import VuePhoneNumberInput from 'vue-phone-number-input'
import myUpload from 'vue-image-crop-upload/upload-2.vue'
import { extend, ValidationProvider, ValidationObserver } from 'vee-validate'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import 'vue-form-wizard/dist/vue-form-wizard.min.css'
import 'vue-phone-number-input/dist/vue-phone-number-input.css'
import * as rules from 'vee-validate/dist/rules'
import {
  BImg,
  BButton,
  BCardText,
  BCard,
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BBadge,
  BLink,
  VBTooltip,
} from 'bootstrap-vue'
import { required, email } from '@validations'
import Ripple from 'vue-ripple-directive'
import store from '@/store'
import { mapGetters } from 'vuex'

Object.keys(rules).forEach(rule => {
  extend(rule, rules[rule])
})

/* eslint-disable global-require */
export default {
  components: {
    ValidationProvider,
    ValidationObserver,
    FormWizard,
    TabContent,
    BButton,
    BCard,
    BCardText,
    BRow,
    BCol,
    BImg,
    BFormGroup,
    BFormInput,
    BBadge,
    VuePhoneNumberInput,
    myUpload,
    BLink,
  },
  directives: {
    'b-tooltip': VBTooltip,
    Ripple,
  },
  data() {
    return {
      googleMap: {
        baseURL: `https://maps.googleapis.com/maps/api/staticmap?key=${process.env.VUE_APP_MAP_KEY}`,
        zoom: 17,
        markers: {
          lat: 25.0401,
          lng: 121.5120,
          size: 'normal',
          icon: 'https://trackhelps.com/assets/img/Logo_32x32.png',
        },
        language: 'zh-tw',
        format: 'png',
        maptype: 'raodmap',
        size: '400x206',
        scale: '1',
        style: 'feature:poi|visibility:off',
      },
      googleMapURL: '',
      campaignForm: {
        slug: '',
        address: '',
        formattedAddress: '',
        zip: '',
        country: '',
        contactNumber: '',
        campaignName: '',
        types: [],
        geoLocation: {},
        imgDataUrl: '',
        countryCode: '',
        govQrcode: '',
      },
      phoneNumber: '',
      required,
      email,
      secondary: false,
      secondaryList: [],
      isActive: {},
      campaignTypes: [
        {
          name: 'entertainment',
          labor: '娛樂',
          desc: 'Bar、夜店、電影院、KTV、藝廊',
          secondary: [
            { name: 'night-club', labor: '夜店' },
            { name: 'bar', labor: 'Bar' },
            { name: 'cinema', labor: '電影院' },
            { name: 'ktv', labor: 'KTV' },
            { name: 'art-gallery', labor: '藝廊' },
            { name: 'other', labor: '其他' },
          ],
        },
        {
          name: 'event',
          labor: '活動',
          desc: '足球、籃球、棒球、羽球、演唱會、研討會',
          secondary: [
            { name: 'soccer', labor: '足球' },
            { name: 'basketball', labor: '籃球' },
            { name: 'baseball', labor: '棒球' },
            { name: 'badminton', labor: '羽球' },
            { name: 'seminar', labor: '研討會' },
            { name: 'concert', labor: '演唱會' },
            { name: 'other', labor: '其他' },
          ],
        },
        {
          name: 'fnb',
          labor: '餐飲',
          desc: '餐廳、咖啡廳',
          secondary: [
            { name: 'restaurant', labor: '餐廳' },
            { name: 'cafe', labor: '咖啡廳' },
            { name: 'other', labor: '其他' },
          ],
        },
        {
          name: 'medical',
          labor: '醫療',
          desc: '診所、復健、牙醫、醫院、其他',
          secondary: [
            { name: 'clinic', labor: '診所' },
            { name: 'chiropractor', labor: '復健' },
            { name: 'dentist', labor: '牙醫' },
            { name: 'hospital', labor: '醫院' },
            { name: 'other', labor: '其他' },
          ],
        },
        {
          name: 'service',
          labor: '服務業',
          desc: '美甲、美髮、按摩、SPA、美容、紋身',
          secondary: [
            { name: 'nail-salon', labor: '美甲' },
            { name: 'hair-salon', labor: '美髮' },
            { name: 'animal-salon', labor: '寵物美容' },
            { name: 'massage', labor: '按摩' },
            { name: 'spa', labor: 'SPA' },
            { name: 'beauty-salon', labor: '美容' },
            { name: 'tattoo', labor: '紋身' },
            { name: 'other', labor: '其他' },
          ],
        },
        {
          name: 'merchant',
          labor: '商家',
          desc: '百貨公司、超級市場、便利商店、零售',
          secondary: [
            { name: 'department-store', labor: '百貨公司' },
            { name: 'supermarket', labor: '超級市場' },
            { name: 'convenience-store', labor: '便利商店' },
            { name: 'retail', labor: '零售' },
            { name: 'other', labor: '其他' },
          ],
        },
        {
          name: 'education',
          labor: '教育',
        },
        {
          name: 'office',
          labor: '公司',
        },
        {
          name: 'building',
          labor: '大樓',
        },
        {
          name: 'other',
          labor: '其他',
        },
      ],
      phoneInput: {
        noFlags: true,
        default: 'TW',
        color: '#B9524F',
        errorColor: '#ea5455',
        error: false,
        required: true,
        valid: '#d8d6de',
        showCode: true,
        top: ['TW', 'JP', 'TH', 'CN', 'HK'],
        noState: true,
        size: 'sm',
        imgFormat: 'png',
      },
      numberIsValid: false,
      imageUpload: false,
      QrcodeUpload: false,
    }
  },
  computed: {
    ...mapGetters(['userCampaigns', 'user']),
  },
  methods: {
    setMapUrl() {
      this.googleMapURL = this.googleMap.baseURL
      Object.entries(this.googleMap).forEach(([key, item]) => {
        if (key === 'markers') {
          this.googleMapURL += `&markers=size:${this.googleMap.markers.size}|icon:${this.googleMap.markers.icon}|${this.googleMap.markers.lat},${this.googleMap.markers.lng}`
        } else if (key !== 'baseURL' && key !== 'key') {
          this.googleMapURL += `&${key}=${item}`
        }
      })
    },
    removeImg(img) {
      this.campaignForm[img] = ''
    },
    cropSuccess(imgDataUrl) {
      this.campaignForm.imgDataUrl = imgDataUrl
    },
    cropQrcode(QrcodeUrl) {
      this.campaignForm.govQrcode = QrcodeUrl
    },
    updateForm(data) {
      if (data.isValid) {
        this.numberIsValid = true
        this.phoneInput.error = false
        this.campaignForm.contactNumber = data.formattedNumber
        this.campaignForm.countryCode = data.countryCode
      } else {
        this.numberIsValid = false
        this.phoneInput.error = true
      }
    },
    formSubmitted() {
      store.dispatch('createCampaign', { ...this.campaignForm, paymentType: this.user.payment.type }).then(campaign => {
        if (this.campaignForm.imgDataUrl !== '') {
          store.dispatch('uploadCampaignImage', {
            data: this.campaignForm.imgDataUrl, name: campaign.cid, uid: campaign.cuid, type: 'data_url', cid: campaign.cid, colName: 'logoImgURL',
          })
        }
        if (this.campaignForm.govQrcode !== '') {
          store.dispatch('uploadCampaignImage', {
            data: this.campaignForm.govQrcode, name: `${campaign.cid}-govqrcode`, uid: campaign.cuid, type: 'data_url', cid: campaign.cid, colName: 'govImgURL',
          })
        }
        fetch(this.googleMapURL).then(res => res.blob()).then(blob => {
          store.dispatch('uploadCampaignImage', {
            data: blob, name: `${campaign.cid}-gmap`, uid: campaign.cuid, type: 'blob', cid: campaign.cid, colName: 'mapImgURL',
          })
        })
        this.$emit('update')
      })

      this.$toast({
        component: ToastificationContent,
        props: {
          title: 'Form Submitted',
          icon: 'EditIcon',
          variant: 'success',
        },
      })
    },
    validationFormType() {
      // TODO: Need a better way of doing this
      // Fix: click around code not working
      return new Promise((resolve, reject) => {
        if ((this.campaignForm.types.length === 1 && this.secondaryList.length === 0) || this.campaignForm.types.length === 2) {
          resolve(true)
        } else {
          reject()
        }
      })
    },
    validationFormInfo() {
      return new Promise((resolve, reject) => {
        this.$refs.infoRules.validate().then(success => {
          if (!this.numberIsValid) {
            this.$refs.contactNumber.applyResult({
              errors: ['電話格式有誤'], // array of string errors
              valid: false, // boolean state
              failedRules: {}, // should be empty since this is a manual error.
            })
            reject()
          } else if (success) {
            store.dispatch('isSlugExist', this.campaignForm.slug).then(exist => {
              if (exist) {
                this.$refs.slug.applyResult({
                  errors: ['簡址已被使用'], // array of string errors
                  valid: false, // boolean state
                  failedRules: {}, // should be empty since this is a manual error.
                })
                reject()
              } else {
                const adds = `${this.campaignForm.address}, ${this.campaignForm.country}, ${this.campaignForm.zip}`
                store.dispatch('geoAddress', adds).then(campaign => {
                  // this.googleMap.center = campaign.geoLocation
                  this.campaignForm.geoLocation = campaign.geoLocation
                  this.googleMap.markers.lat = campaign.geoLocation.lat
                  this.googleMap.markers.lng = campaign.geoLocation.lng
                  this.campaignForm.formattedAddress = campaign.formattedAddress
                  this.setMapUrl()
                })
                resolve(true)
              }
            })
          } else {
            reject()
          }
        })
      })
    },
    validationFormSocial() {
      return new Promise((resolve, reject) => {
        this.$refs.socialRules.validate().then(success => {
          if (success) {
            resolve(true)
          } else {
            reject()
          }
        })
      })
    },
    goBack() {
      this.secondary = false
      this.secondaryList = []
      this.isActive = {}
      this.campaignForm.types.splice(0)
    },
    goNext(type) {
      setTimeout(() => {
        if (this.secondary) {
          this.campaignForm.types.push(type.name)
          this.isActive.secondary = {
            [type.name]: true,
          }
        } else if (typeof (type.secondary) !== 'undefined') {
          this.isActive = {
            [type.name]: true,
            secondary: {},
          }
          this.campaignForm.types.push(type.name)
          this.secondary = true
          this.secondaryList = type.secondary
        } else {
          this.campaignForm.types.push(type.name)
          this.isActive = {
            [type.name]: true,
            secondary: {},
          }
        }
      }, 200)
    },
    formatter(value) {
      return value.toLowerCase()
    },
  },
}
</script>

<style lang="scss">
  @import '@core/scss/vue/libs/vue-wizard.scss';
  @import '@core/scss/vue/libs/vue-select.scss';
</style>

<style lang="scss">
  .ecommerce-card {
    &:hover {
      transform: translateY(-5px);
      box-shadow: 0 4px 25px 0 rgba(black, 0.25);
    }
    &:after {
        background-color: rgba(0, 0, 0, 0.2);
    }
  }

  .equal {
    display: flex;
    flex-wrap: wrap;
  }
  @media (max-width: 1024px) {
    .icon-card {
      width: 126px;
    }
  }

  @media (max-width: 768px) {
    .icon-card {
      width: 131px;
    }
  }

  @media (max-width: 414px) {
    .icon-card {
      width: 110px;
    }
  }

  @media (max-width: 375px) {
    .icon-card {
      width: 150px;
    }
  }
</style>
